<template>
    <div class="container">
        <div class="row trip-stats">
            <div class="four col-md-3">
                <div class="counter-box colored"> <i class="fas fa-car"></i> <span class="counter">{{parseFloat(totalDistance).toFixed(2)}} KM</span>
                    <p>Distance Travelled</p>
                </div>
            </div>
            <div class="four col-md-3">
                <div class="counter-box"> <i class="fas fa-gas-pump"></i> <span class="counter">{{parseFloat(totalFuel).toFixed(2)}} Litres</span>
                    <p>Fuel Consumption</p>
                </div>
            </div>
            <div class="four col-md-3">
                <div class="counter-box"> <i class="fas fa-smog"></i> <span class="counter">{{parseFloat(totalCO2).toFixed(2)}} KG</span>
                    <p>CO2 Burned</p>
                </div>
            </div>
            <div class="four col-md-3">
                <div class="counter-box"> <i class="fas fa-tachometer-alt"></i> <span class="counter">{{parseFloat(averageSpeed).toFixed(2)}} KM/Hour</span>
                    <p>Average Speed</p>
                </div>
            </div>
        </div>

        <div class="row">
        <table id="trips" class="table table-bordered table-hover">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">Start Time</th>
                    <th scope="col">End Time </th>
                    <th>Distance</th>
                    <th>Fuel</th>
                    <th>Fuel Cost</th>
                    <th>CO2</th>
                    <th>Average Speed</th>
                    <th>Economy</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="trip in trips" :key="trip.id">
                    <td>{{trip.startTime}}</td>
                    <td>{{trip.endTime}}</td>
                    <td>{{parseFloat(trip.distance).toFixed(2)}}</td>
                    <td>{{parseFloat(trip.litres).toFixed(2)}}</td>
                    <td>{{parseFloat(trip.fuelCost).toFixed(2)}}</td>
                    <td>{{parseFloat(trip.co2).toFixed(2)}}</td>
                    <td>{{parseFloat(trip.averageSpeed).toFixed(2)}}</td>
                    <td>{{parseFloat(trip.litresPerHundredKm).toFixed(2)}}</td>
                    <td><a :href="'/trip/' + trip.id + '/tripdetail'"><i class="fas fa-list"></i></a></td>
                </tr>
            </tbody>
        </table>
    </div>

    </div>
    
</template>

<script>
import axios from 'axios';

export default {
    name: 'Trip',
    data() {
        return {
            trips: [],
            totalDistance: 0,
            totalFuel: 0,
            totalCO2: 0,
            averageSpeed: 0
        }
    },
    created() {
        this.fetchTrips();
    },
    methods: {
        async fetchTrips(){
            const result = await axios({
                method: 'get',
                url: `https://api.gofar.co/api/vehicles/${this.$route.params.id}/trips`,
                headers: {
                    'Authorization': localStorage.getItem('access_token')
                }
            });
            this.trips = result.data;
            this.totalDistance = result.data.filter((trip)=> trip.distance && trip.distance !== '').map((trip)=> trip.distance).reduce((total, distance)=> parseFloat(total) +  parseFloat(distance));
            this.totalFuel = result.data.filter((trip)=> trip.litres && trip.litres !== '').map((trip)=> trip.litres).reduce((total, litres)=> parseFloat(total) +  parseFloat(litres));
            this.totalCO2 = result.data.filter((trip)=> trip.co2 && trip.co2 !== '').map((trip)=> trip.co2).reduce((total, co2)=> parseFloat(total) +  parseFloat(co2));
            const totalAverageSpeed = result.data.filter((trip)=> trip.averageSpeed && trip.averageSpeed !== '').map((trip)=> trip.averageSpeed).reduce((total, averageSpeed)=> parseFloat(total) +  parseFloat(averageSpeed));
            this.averageSpeed = totalAverageSpeed / result.data.length;
        }
    }
}
</script>


<style scoped>
.container {
    margin-top: 20px;
}

.trip-stats{
    margin-bottom: 20px;
}

.counter-box {
    display: block;
    background: #f6f6f6;
    padding: 40px 20px 37px;
    text-align: center
}

.counter-box p {
    margin: 5px 0 0;
    padding: 0;
    color: #909090;
    font-size: 18px;
    font-weight: 500
}

.counter-box i {
    font-size: 60px;
    margin: 0 0 15px;
    color: #d2d2d2
}

.counter {
    display: block;
    font-size: 32px;
    font-weight: 700;
    color: #666;
    line-height: 28px
}

.counter-box.colored {
    background: #3acf87
}

.counter-box.colored p,
.counter-box.colored i,
.counter-box.colored .counter {
    color: #fff
}
</style>